(function () {
    "use strict";

    angular
        .module('iMatApp')
        .directive('alias', aliasDirective);

    aliasDirective.$inject = [];

    function aliasDirective() {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element, attrs) {
                scope.$watch(attrs.alias, function () {
                    if (attrs.as) {
                        scope[attrs.as] = scope.$eval(attrs.alias);
                    } else {
                        angular.extend(scope, scope.$eval(attrs.alias));
                    }
                }, angular.isDefined(attrs.deepCheck));
            }
        };
    }
})();